<template>
<v-container>
  <v-card>
    <v-container>
      <v-layout>
        <v-flex>
        <h1>How to turn on/off Kontakt card</h1>
        <p>Kontakt.io Card Beacons are equipped in small ON/OFF switch.</p>
        <p>Considering the lanyard hole is the top of Beacon, move the switch to the left to turn it ON or move the switch to the right to turn it OFF.</p>
        <p>When Card Beacon is OFF it will not broadcasting any BLE signal and cannot be read by any Bluetooth devices.</p>
        <p>Below illustration shows how to turn on/off Card Beacon.</p>
        <img src="@/assets/onOff.gif" style="width: 100%; max-width: 500px"/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</v-container>
</template>

<script>
export default {};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/CardInfo.vue